import { TripTypeOptions } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { PaxTypeCodes } from '../../constants/common.constants';
import {
  CatalogApiFieldsConfig,
  CatalogApiFieldsValue,
  CatalogApiResponse
} from '../../models/core-apis/catalog-api.interfaces';
import { stringToBoolean } from '../utils/utils.adapter';

export const prepareCatalogApiFieldsValue = (
  catalogApiData: CatalogApiResponse | null
): CatalogApiFieldsValue | null => {
  if (catalogApiData) {
    const tripTypeOptions: TripTypeOptions[] = [];
    let selectTripType = catalogApiData.journeyTypeOptions.Values[0].value;

    catalogApiData.journeyTypeOptions.Values.forEach(
      ({ isDefaulted, value }) => {
        tripTypeOptions.push(value);

        if (stringToBoolean(isDefaulted)) {
          selectTripType = value;
        }
      }
    );

    const paxDefault = catalogApiData.paxDefaults.Values.find(
      ({ paxCode }) => paxCode === PaxTypeCodes.ADULT
    );
    const selectedPaxValue = Number(paxDefault?.defaultCount);
    const maxPaxCount = Number(paxDefault?.maximumPaxCount);

    const bestFareOptions = catalogApiData.fareBrandsByMoney.Values;

    return {
      tripTypeOptions,
      selectTripType,
      selectedPaxValue,
      maxPaxCount,
      bestFareOptions,
      basicFaresChecked: catalogApiData.defaultMap.basicFaresChecked
    };
  }

  return null;
};

export const prepareCatalogApiFieldsConfig = (
  catalogApiData: CatalogApiResponse | null
): CatalogApiFieldsConfig | null => {
  if (catalogApiData) {
    const {
      disableBestFares,
      disableEdocLink,
      disableFlexibleDates,
      disableMeetingCode,
      disableNearbyAirport,
      disablePaxDropDown,
      disableRefundableFares,
      disableShowPriceIn: disableShopMiles,
      disableTripType,
      defaultMap: { showBasicFares }
    } = catalogApiData;

    return {
      disableBestFares,
      disableEdocLink,
      disableFlexibleDates,
      disableMeetingCode,
      disableNearbyAirport,
      disablePaxDropDown,
      disableRefundableFares,
      disableShopMiles,
      disableTripType,
      showBasicFares
    };
  }

  return null;
};
